import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  BFFGetMasterTemplatesByParamsRequestPayload,
  BFFGetMasterTemplatesByParamsResponsePayload,
  BFFCreateMasterTemplateResponsePayload,
  BFFCreateMasterTemplateRequestPayload,
  BFFGetMasterTemplatesCoverageResponsePayload,
  BFFGetMasterTemplatesCoverageRequestPayload,
  BFFGetMasterTemplateByIdResponsePayload,
  BFFUpdateMasterTemplateByIdRequestPayload,
  BFFUpdateMasterTemplateByIdResponsePayload,
} from '@cpak/adp-cpak-bff-service-models';
import { FetcherService } from './fetcher/fetcher.service';

@Injectable({
  providedIn: 'root',
})
export class TemplateService {
  public constructor(private readonly http: FetcherService) {}

  public getMasterTemplates(
    params: BFFGetMasterTemplatesByParamsRequestPayload
  ): Observable<BFFGetMasterTemplatesByParamsResponsePayload | null> {
    return this.http.get<BFFGetMasterTemplatesByParamsResponsePayload>(`/api/pages/masterTemplates`, { ...params });
  }

  public getMasterTemplate(templateId: string): Observable<BFFGetMasterTemplateByIdResponsePayload | null> {
    return this.http.get<BFFGetMasterTemplateByIdResponsePayload>(`/api/pages/masterTemplates/${templateId}`);
  }

  public patchMasterTemplate(
    requestData: Partial<BFFUpdateMasterTemplateByIdRequestPayload>
  ): Observable<BFFUpdateMasterTemplateByIdResponsePayload | null> {
    return this.http.patch<BFFUpdateMasterTemplateByIdResponsePayload>(
      `/api/pages/masterTemplates/${requestData.id}`,
      requestData.data
    );
  }

  public createMasterTemplate({
    data,
  }: Pick<BFFCreateMasterTemplateRequestPayload, 'data'>): Observable<BFFCreateMasterTemplateResponsePayload | null> {
    return this.http.put<BFFCreateMasterTemplateResponsePayload>('/api/pages/masterTemplates', { ...data });
  }

  public getMasterTemplatesCoverage({
    plant,
  }: BFFGetMasterTemplatesCoverageRequestPayload): Observable<BFFGetMasterTemplatesCoverageResponsePayload | null> {
    return this.http.get<BFFGetMasterTemplatesCoverageResponsePayload>(
      `/api/pages/masterTemplates/coverage`,
      plant ? { plant } : {}
    );
  }
}
